import jwt_decode from 'jwt-decode';
import Swal from 'sweetalert2';
import LoginApi from '../pages/login/login.api';
import { LOCAL_STORAGE_TOKEN, LOCAL_STORAGE_USUARIO } from '../localStorage.util';
import * as usuarioActions from '@common/usuario/usuario.action';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import React, {
    useEffect, useRef, useState
} from 'react';
import {
    getUsuarioLocalStorage,
    getTokenLocalStorage,
} from '../localStorage.util';

function AuthProvider() {
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [lastActivity, setLastActivity] = useState(Date.now());
    const CryptoJS = require('crypto-js');
    const intl = useIntl();
    let user = getUsuarioLocalStorage();
    let token = getTokenLocalStorage();
    const exp = 60000;
    const autoRenewTimeLimit = 300000;
    let timerInterval;
    let key = token && token.replace('bearer ', '');
    useEffect(() => {
        console.log('tokentimeout', tokenTimeout(key));
        timerInterval && clearInterval(timerInterval);
        user && token && !isTokenExpired && verificaToken(key);
    }, [user]);

    const refreshToken = () => {
        handleRefresh();
        token = getTokenLocalStorage();
        user = getUsuarioLocalStorage();
        key = token && token.replace('bearer ', '');
    };

    const handleUserActivity = () => {
        const currentTime = Date.now();
        setLastActivity(currentTime);
        refDate.current = currentTime;
    };

    const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);
    const refDate = useRef(Date.now());
    const logDate =(message, date) => {
        var dt = new Date(date);
        console.log(message,`${
            padL(dt.getMonth()+1)}/${
            padL(dt)}/${
                dt.getFullYear()} ${
            padL(dt.getHours())}:${
            padL(dt.getMinutes())}:${
            padL(dt.getSeconds())}`
        );
    }

    useEffect(() => {
        document.addEventListener('mousemove', handleUserActivity);
        document.addEventListener('keydown', handleUserActivity);

        return () => {
            document.removeEventListener('mousemove', handleUserActivity);
            document.removeEventListener('keydown', handleUserActivity);
        };
    }, [lastActivity]);

    const handleRefresh = () => {
        console.log('Refreshing token...');
        LoginApi.refreshToken().then((res) => {
            localStorage.setItem(
                LOCAL_STORAGE_TOKEN,
                `${res.data.tokenType} ${res.data.accessToken}`
            );
            LoginApi.obterRestricoesAcesso(res.data.usuarioId)
                .then((acessos) => {
                    let payload = {
                        role: acessos.data,
                        usuario: res.data.nomeCompleto,
                        usuarioId: res.data.usuarioId,
                        medicoId: res.data.medicoId,
                        medico: res.data.nomeMedico,
                        isResidente: res.data.isResidente,
                    };

                    usuarioActions.atualizarUsuario(payload);

                    if (acessos.data) {
                        const decoded = jwt_decode(res.data.accessToken);
                        usuarioActions.permissaoUsuario(acessos.data);
                        const encrypted = CryptoJS.AES.encrypt(
                            JSON.stringify(acessos.data),
                            decoded.jti,
                        ).toString();

                        const hmac = CryptoJS.HmacSHA256(
                            encrypted,
                            CryptoJS.SHA256(decoded.jti)
                        ).toString();
                        const transitmessage = hmac + encrypted;
                        payload.role = transitmessage;
                    }
                    localStorage.setItem(
                        LOCAL_STORAGE_USUARIO,
                        JSON.stringify(payload)
                    )
                });

            Swal.close();
            setIsTokenExpired(false);
            verificaToken(res.data.accessToken);

        });

    };

    function signout() {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN);

        window.location.href = '/';
    }

    function checkToken() {
        Swal.fire({
            allowOutsideClick: false,
            title: intl.formatMessage({ id: 'message.expired' }),
            timerProgressBar: true,
            html: intl.formatMessage({ id: 'message.expired.renewSession' }),
            timer: exp,
            showConfirmButton: false,
            onBeforeOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector('b');
                const increase = document.getElementById('increase');
                increase.addEventListener('click', handleRefresh);
                timerInterval = setInterval(() => {
                    let seconds = (Swal.getTimerLeft() / 1000) % 60;
                    b.textContent = Math.round(seconds);
                }, 100);
            },
            willClose: () => {
                clearInterval(timerInterval);
            },
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                signout();

            }
        });
    }
    const verificaToken = (token) => {
        let time;
        time && clearTimeout(time);

        setIsTokenExpired(true);

        if (tokenTimeout(token) < 0) {
            signout()
        } else {

            time = setTimeout(() => {

                const currentTime = Date.now();
                // const timeDifferenceInSeconds = Math.floor((currentTime - refDate.current) / 1000);
                // console.log('refreshing, Current Time:', currentTime);
                // console.log('refreshing, Last User Activity Time:', refDate.current);
                // console.log('refreshing, Time Difference in Seconds:', timeDifferenceInSeconds);
                // logDate('refreshing last date global state', refDate.current);
                // logDate('refreshing last date local state', lastActivity);
                if (((Date.now() - refDate.current)/1000) <= (autoRenewTimeLimit/1000)) {
                    refreshToken();
                }
                else {
                    checkToken();
                }

            }, tokenTimeout(token));
        }
    };

    const tokenTimeout = (token) => {
        const tokenDecode = jwt_decode(`${token.replace('bearer ', '')}`); //Pega o tokem da a aplicação e decodifica
        const refreshAgora = new Date().getTime();


        return tokenDecode.exp * 1000 - refreshAgora - exp;
    }
}


export default AuthProvider;



// WEBPACK FOOTER //
// ./src/helpers/authProvider.js